import { AlertDescription as ChakraAlertDescription } from '@chakra-ui/react';

type AlertDescriptionProps = React.ComponentProps<
  typeof ChakraAlertDescription
>;

const AlertDescription = ({
  children,
  ...props
}: Readonly<AlertDescriptionProps>) => {
  return <ChakraAlertDescription {...props}>{children}</ChakraAlertDescription>;
};

export default AlertDescription;
